import {
  BACKGROUND_ATTENTION_COLOR_DIAMOND,
  BACKGROUND_ATTENTION_COLOR_GOLD,
  BACKGROUND_ATTENTION_COLOR_RUBY,
  COINS_COLOR,
  DIAMOND_COLOR,
  RUBY_COLOR
} from "../styles/constants";

export const FACTIONS = {
  AQUARS: 'aquars',
  BEASTMEN: 'beastmen',
  CELECTIALS: 'celectials',
  DARK_ELVES: 'dark_elves',
  DEMONS: 'demons',
  DOPPLERS: 'dopplers',
  DRAGONS: 'dragons',
  DWARVES: 'dwarves',
  ELEMENTALS: 'elementals',
  ELVES: 'elves',
  ENLIGHTENED: 'enlightened',
  ENTS: 'ents',
  FENIX: 'fenix',
  GIANTS: 'giants',
  GOBLINS: 'goblins',
  GREMLINS: 'gremlins',
  HUMANS: 'humans',
  INSECTOIDS: 'insectoids',
  LEPRECHAUNS: 'leprechauns',
  MUSHROOM_PEOPLE: 'mushroom_people',
  ORCS: 'orcs',
  RATMEN: 'ratmen',
  SPIRITS: 'spirits',
  SUCCUBES: 'succubes',
  TECHNODWARVES: 'technodwarves',
  UNDEAD: 'undead',
  VENTORY: 'ventory',
  WIZARDS: 'wizards',
}

export const RANK_NAME_COLORS = {
  ruby: RUBY_COLOR,
  diamond: DIAMOND_COLOR,
  gold: COINS_COLOR,
};
export const RANK_BACKGROUND_COLORS = {
  ruby: BACKGROUND_ATTENTION_COLOR_RUBY,
  diamond: BACKGROUND_ATTENTION_COLOR_DIAMOND,
  gold: BACKGROUND_ATTENTION_COLOR_GOLD,
};

